import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { MapPin, Clock, Phone, Star, ArrowRight, Zap, UtensilsCrossed, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const FOOD_IMAGES = {
  tacos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/nppzerfn_Chicken%20Tacos.jpg",
  burrito: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/vh8qredt_Chipotle%20Paneer%20Burrito.jpg",
  nachos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/durdbnx1_Tex%20Mex%20Chicken%20Nachos.jpg",
  churros: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mar8qk2z_Churros.jpg",
  patatas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/mkm7u8jw_Patatas%20Bravas.jpg",
  enchiladas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/9oip3hws_Enchiladas%281%29.jpg",
  fajitas: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/x6zxb47k_Chicken%20Fajitas.jpg",
  taquitos: "https://customer-assets.emergentagent.com/job_045563bf-4bdb-48a2-991f-697b1fca894b/artifacts/8fi8nnbz_Taquitos.jpg",
  interior1: "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/wgn5ctmv_WhatsApp%20Image%202026-03-26%20at%2012.30.53%20%282%29.jpeg",
  interior2: "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/ig40hm8q_WhatsApp%20Image%202026-03-26%20at%2012.30.53%20%283%29.jpeg",
  interior3: "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/6nm4g6t5_WhatsApp%20Image%202026-03-26%20at%2012.30.52%20%282%29.jpeg",
  interior4: "https://customer-assets.emergentagent.com/job_882d595f-ff74-4a1a-b1f3-db9ebf1484f1/artifacts/a1abbu6u_WhatsApp%20Image%202026-03-26%20at%2012.30.52.jpeg",
  foodCourt1: "https://images.unsplash.com/photo-1720777636417-bc75f5203e38?crop=entropy&cs=srgb&fm=jpg&w=800&h=500&fit=crop",
  foodCourt2: "https://images.unsplash.com/photo-1653860468798-6e1b03654ff1?crop=entropy&cs=srgb&fm=jpg&w=800&h=500&fit=crop",
  foodCourt3: "https://images.unsplash.com/photo-1593160688806-4a3604ef4cbd?crop=entropy&cs=srgb&fm=jpg&w=800&h=500&fit=crop"
};

const expressLocations = [
  {
    id: 1, name: "Raheja Mindspace", city: "Hyderabad",
    address: "Ground Floor, Building Number 9, Mindspace Madhapur Rd, HUDA Techno Enclave, HITEC City, Hyderabad, Telangana 500081",
    hours: "11AM – 9PM", phone: "+91 883 911 0698",
    color: "#EE2535", shadow: "#EE2535",
    photos: [FOOD_IMAGES.interior1, FOOD_IMAGES.interior2, FOOD_IMAGES.tacos, FOOD_IMAGES.burrito]
  },
  {
    id: 2, name: "Neville Food Court", city: "Chennai",
    address: "Ramanujan Intellion Park, Neville Tower, Isthara Food Court, Ground Floor, Chennai, Tamil Nadu",
    hours: "11AM – 9PM", phone: "+91 93440 07948",
    color: "#51A262", shadow: "#51A262",
    photos: [FOOD_IMAGES.foodCourt1, FOOD_IMAGES.nachos, FOOD_IMAGES.interior3, FOOD_IMAGES.fajitas]
  },
  {
    id: 3, name: "Keppel Food Court", city: "Chennai",
    address: "One Paramount, 110, Mount Poonamallee Rd, Porur, Chennai, Greater Chennai, Tamil Nadu 600116",
    hours: "11AM – 9PM", phone: "+91 93440 07948",
    color: "#F7B638", shadow: "#F7B638",
    photos: [FOOD_IMAGES.foodCourt3, FOOD_IMAGES.patatas, FOOD_IMAGES.foodCourt2, FOOD_IMAGES.enchiladas]
  }
];

const expressMenu = {
  starters: {
    title: "Starters", image: FOOD_IMAGES.patatas,
    items: [
      { name: "Loco Fries", type: "Veg" },
      { name: "Loco Cheesy Fries", type: "Veg", desc: "Fries with cheese blend, nacho cheese & pico de gallo" },
      { name: "Cheesy Nachos", type: "Veg", desc: "Tortilla chips with cheese blend, lettuce, nacho cheese & pico de gallo" },
      { name: "Beans Cheese Nachos", type: "Veg" },
      { name: "Crispy Chicken Tenders", type: "Non Veg" },
      { name: "Cheesy Quesadilla", type: "Veg" }
    ]
  },
  tacos: {
    title: "Tacos", image: FOOD_IMAGES.tacos,
    items: [
      { name: "Cheese Taco", type: "Veg", desc: "Tortilla with cheese, lettuce & pico de gallo" },
      { name: "Chicken Chipotle", type: "Non Veg", desc: "Chipotle chicken, cheese, lettuce & pico de gallo" },
      { name: "Chicken Tex Mex", type: "Non Veg", desc: "Tex-Mex chicken, cheese, lettuce, sour cream & pico de gallo" },
      { name: "Chicken Tinga", type: "Non Veg", desc: "Tinga chicken, cheese, lettuce & pico de gallo" },
      { name: "Mushroom Chipotle", type: "Veg", desc: "Chipotle mushroom, cheese, lettuce & pico de gallo" },
      { name: "Paneer Chipotle", type: "Veg", desc: "Chipotle paneer, cheese, lettuce & pico de gallo" },
      { name: "Huevo", type: "Veg", desc: "Fried egg with cheese, lettuce & pico de gallo" }
    ]
  },
  tortas: {
    title: "Tortas (Mexican Sandwiches)", image: FOOD_IMAGES.taquitos,
    items: [
      { name: "Cheesy Sandwich", type: "Veg", desc: "Cheese blend, lettuce & pico de gallo in toasted Mexican bolillo bread with fries" },
      { name: "Torta De Huevo", type: "Veg", desc: "Fluffy seasoned eggs with beans, melted cheese, lettuce & creamy chipotle sauce with fries" },
      { name: "Torta De Pollo A La Parrilla", type: "Non Veg", desc: "Grilled chicken with beans, cheese, lettuce & smoky chipotle mayo with fries" },
      { name: "Torta De Paneer A La Parrilla", type: "Veg", desc: "Spiced grilled paneer with beans, melted cheese, lettuce & creamy dressing with fries" }
    ]
  },
  fiestaBowls: {
    title: "Fiesta Bowls", image: FOOD_IMAGES.fajitas,
    items: [
      { name: "Chicken Chipotle", type: "Non Veg" },
      { name: "Chicken Tex Mex", type: "Non Veg" },
      { name: "Chicken Tinga", type: "Non Veg" },
      { name: "Mushroom Chipotle", type: "Veg" },
      { name: "Paneer Chipotle", type: "Veg" }
    ],
    note: "All include refried beans, Mexican rice, lettuce, salsa, red pickled onion, pico de gallo and your choice of sauce"
  },
  burritos: {
    title: "Burritos", image: FOOD_IMAGES.burrito,
    items: [
      { name: "Chicken Chipotle", type: "Non Veg" },
      { name: "Chicken Tex Mex", type: "Non Veg" },
      { name: "Chicken Tinga", type: "Non Veg" },
      { name: "Mushroom Chipotle", type: "Veg" },
      { name: "Paneer Chipotle", type: "Veg" }
    ],
    note: "All include refried beans, Mexican rice, cheese, pico de gallo and coriander-lime & taco sauce"
  },
  saladBowls: {
    title: "Salad Bowls", image: FOOD_IMAGES.enchiladas,
    items: [
      { name: "Grilled Coriander Paneer", type: "Veg", desc: "Fresh garden greens with grilled coriander-marinated paneer and zesty fiesta dressing" },
      { name: "Boiled Egg Fiesta", type: "Veg", desc: "Sliced boiled egg over crisp greens, fresh vegetables, and fiesta dressing" },
      { name: "Grilled Chicken", type: "Non Veg", desc: "Tender grilled chicken over crisp greens with fiesta dressing" },
      { name: "Chicken Tenders", type: "Non Veg", desc: "Tender fried chicken over crisp greens with fiesta dressing" }
    ]
  },
  combos: {
    title: "Combos", image: FOOD_IMAGES.nachos,
    items: [
      { name: "Sandwich + Fries + Beverage", type: "Veg" },
      { name: "Burrito + Fries + Beverage", type: "Veg" },
      { name: "2 Tacos + Fries + Beverage", type: "Veg" },
      { name: "Fiesta Bowl + Fries + Beverage", type: "Veg" }
    ]
  },
  dessertDrinks: {
    title: "Dessert & Add-Ons", image: FOOD_IMAGES.churros,
    items: [
      { name: "Churros", type: "Veg", desc: "With chocolate dipping sauce" },
      { name: "Mozzarella Cheese (Add-On)", type: "Veg" },
      { name: "Nacho Cheese (Add-On)", type: "Veg" },
      { name: "Paneer (Add-On)", type: "Veg" },
      { name: "Mushrooms (Add-On)", type: "Veg" },
      { name: "Refried Beans (Add-On)", type: "Veg" }
    ]
  }
};

const menuCategories = Object.keys(expressMenu);

const LocationGallery = ({ photos, name }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setIdx((prev) => (prev + 1) % photos.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [photos.length]);
  return (
    <div className="relative aspect-video overflow-hidden" data-testid="location-gallery">
      <img src={photos[idx]} alt={`${name} - Photo ${idx + 1}`} className="w-full h-full object-cover transition-opacity duration-300" />
      <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
        {photos.map((_, i) => (
          <button key={i} onClick={() => setIdx(i)}
            className={`w-2 h-2 rounded-full transition-all ${i === idx ? 'bg-[#F7B638] scale-125' : 'bg-white/50'}`}
            aria-label={`Photo ${i + 1}`} />
        ))}
      </div>
      {photos.length > 1 && (
        <>
          <button onClick={() => setIdx((idx - 1 + photos.length) % photos.length)}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center bg-black/40 text-white hover:bg-black/60 transition-colors"
            aria-label="Previous"><ChevronLeft size={16} /></button>
          <button onClick={() => setIdx((idx + 1) % photos.length)}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center bg-black/40 text-white hover:bg-black/60 transition-colors"
            aria-label="Next"><ChevronRight size={16} /></button>
        </>
      )}
    </div>
  );
};

const ExpressPage = () => {
  return (
    <Layout>
      <SEO
        title="Casa Loco Express | Mexican Street Food in Hyderabad & Chennai"
        description="Casa Loco Express brings authentic Mexican street food to food courts near you. Tacos, burritos, tortas, fiesta bowls & more at Raheja Mindspace Hyderabad, Neville & Keppel Food Courts Chennai."
        path="/express"
      />
      <div className="min-h-screen paper-texture" style={{ paddingTop: '76px' }} data-testid="express-page">
        {/* Hero */}
        <div className="py-16 sm:py-20" style={{ backgroundColor: '#EE2535', borderBottom: '4px solid #1A1918' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Star size={14} fill="#F7B638" stroke="none" />
              <Zap style={{ width: '36px', height: '36px', color: '#F7B638' }} />
              <Star size={14} fill="#F7B638" stroke="none" />
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl text-white mb-4" style={{ textShadow: '4px 4px 0 rgba(0,0,0,0.3)' }} data-testid="express-title">
              CASA LOCO EXPRESS
            </h1>
            <div className="zigzag-divider-gold max-w-xs mx-auto mb-5" />
            <p className="font-mono text-white/90 text-sm sm:text-base max-w-xl mx-auto mb-8">
              Authentic Mexican street food — fast, fresh, and full of flavor. Now at food courts near you.
            </p>
            <div className="inline-block px-6 py-3" style={{ backgroundColor: '#F7B638', color: '#1A1918', border: '3px solid #1A1918', boxShadow: '4px 4px 0 #1A1918' }}>
              <span className="font-display text-lg tracking-wider">3 LOCATIONS ACROSS INDIA</span>
            </div>
          </div>
        </div>

        {/* Locations with Photo Galleries */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="text-center mb-12">
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl mb-3" style={{ color: '#1A1918' }}>FIND US NEAR YOU</h2>
            <div className="zigzag-divider max-w-xs mx-auto mb-4" />
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {expressLocations.map((loc) => (
              <div key={loc.id} className="bg-white overflow-hidden transition-transform hover:translate-x-[-3px] hover:translate-y-[-3px]"
                style={{ border: '3px solid #1A1918', boxShadow: `5px 5px 0 ${loc.shadow}` }}
                data-testid={`express-location-${loc.id}`}>
                <LocationGallery photos={loc.photos} name={loc.name} />
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-9 h-9 flex items-center justify-center" style={{ backgroundColor: loc.color }}>
                      <Zap size={18} className="text-white" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg" style={{ color: '#1A1918' }}>{loc.name}</h3>
                      <span className="font-mono text-[10px] uppercase tracking-wider font-bold" style={{ color: loc.color }}>{loc.city}</span>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-start gap-2"><MapPin className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: '#EE2535' }} /><p className="font-mono text-[#4A4641] text-xs">{loc.address}</p></div>
                    <div className="flex items-start gap-2"><Clock className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: '#EE2535' }} /><p className="font-mono text-[#4A4641] text-xs">{loc.hours}</p></div>
                    <div className="flex items-start gap-2"><Phone className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: '#EE2535' }} /><a href={`tel:${loc.phone.replace(/\s/g, '')}`} className="font-mono text-[#4A4641] text-xs hover:text-[#EE2535] transition-colors">{loc.phone}</a></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Express Menu */}
        <div className="py-12 sm:py-16" style={{ backgroundColor: '#1A1918', borderTop: '4px solid #1A1918' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-3 mb-3">
                <Star size={10} fill="#F7B638" stroke="none" />
                <UtensilsCrossed style={{ width: '28px', height: '28px', color: '#F7B638' }} />
                <Star size={10} fill="#F7B638" stroke="none" />
              </div>
              <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl text-white mb-3">EXPRESS MENU</h2>
              <div className="zigzag-divider-gold max-w-xs mx-auto mb-4" />
              <p className="font-mono text-white/50 text-sm">Our best-sellers, made fresh and fast for your food court visit</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {menuCategories.map((catKey) => {
                const cat = expressMenu[catKey];
                return (
                  <div key={catKey} className="overflow-hidden" style={{ border: '3px solid #F7B638', boxShadow: '4px 4px 0 #F7B638' }} data-testid={`express-menu-${catKey}`}>
                    <div className="aspect-[16/9] overflow-hidden">
                      <img src={cat.image} alt={cat.title} className="w-full h-full object-cover" />
                    </div>
                    <div className="p-5" style={{ backgroundColor: '#2A2826' }}>
                      <h3 className="font-display text-xl mb-3" style={{ color: '#F7B638' }}>{cat.title}</h3>
                      <ul className="space-y-2">
                        {cat.items.map((item, i) => (
                          <li key={i} className="font-mono text-xs text-white/80">
                            <div className="flex items-start gap-2">
                              <span className="w-2 h-2 rounded-full flex-shrink-0 mt-1" style={{ backgroundColor: item.type === 'Veg' ? '#51A262' : '#EE2535' }} />
                              <div>
                                <span className="font-bold">{item.name}</span>
                                {item.desc && <p className="text-white/40 text-[10px] mt-0.5">{item.desc}</p>}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {cat.note && <p className="font-mono text-[10px] text-white/30 mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>{cat.note}</p>}
                    </div>
                  </div>
                );
              })}
            </div>

            <p className="font-mono text-white/20 text-[10px] text-center mt-8">*Additional GST charges applicable. Add protein to starters for ₹89. Opt for wheat tortilla for additional ₹25.</p>
          </div>
        </div>

        {/* Value Props */}
        <div className="paper-texture py-12 sm:py-16" style={{ borderTop: '4px solid #1A1918' }}>
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="font-display text-2xl sm:text-3xl text-center mb-8" style={{ color: '#1A1918' }}>THE SAME BOLD FLAVORS, SERVED FAST</h2>
            <div className="grid sm:grid-cols-3 gap-6">
              {[
                { title: 'Fast & Fresh', desc: 'Made to order with fresh ingredients, ready in minutes', bg: '#EE2535' },
                { title: 'Authentic Recipes', desc: 'Same Casa Loco kitchen standards and imported Mexican spices', bg: '#51A262' },
                { title: 'Affordable', desc: 'Premium Mexican street food at food court prices', bg: '#F7B638', dark: true }
              ].map((item, i) => (
                <div key={i} className="p-6 text-center transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
                  style={{ backgroundColor: item.bg, border: '3px solid #1A1918', boxShadow: '4px 4px 0 #1A1918', color: item.dark ? '#1A1918' : 'white' }}>
                  <h3 className="font-display text-lg mb-2">{item.title}</h3>
                  <p className={`font-mono text-xs leading-relaxed ${item.dark ? 'text-[#4A4641]' : 'text-white/80'}`}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="py-10 text-center" style={{ backgroundColor: '#51A262', borderTop: '4px solid #1A1918' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-4">
            <Link to="/food-menu" className="inline-flex items-center gap-2 px-8 py-3 font-display tracking-wider text-base transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
              style={{ backgroundColor: '#F7B638', color: '#1A1918', border: '3px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}>
              VIEW FULL MENU <ArrowRight className="w-5 h-5" />
            </Link>
            <Link to="/about" className="inline-flex items-center gap-2 px-8 py-3 font-display tracking-wider text-base transition-transform hover:translate-x-[-2px] hover:translate-y-[-2px]"
              style={{ backgroundColor: 'white', color: '#1A1918', border: '3px solid #1A1918', boxShadow: '3px 3px 0 #1A1918' }}>
              OUR STORY <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ExpressPage;
